import { type FlagProvider } from '@/features/flags-dev/overrides';

/** `'favourites'` is virtual: a favourited flag renders there INSTEAD of its provider group. */
export type GroupKey = FlagProvider | 'favourites';

export const GROUP_LABELS: Record<GroupKey, string> = {
  favourites: 'Favourites',
  posthog: 'PostHog',
  flagsmith: 'Flagsmith',
};

export const GROUP_ORDER: readonly GroupKey[] = ['favourites', 'posthog', 'flagsmith'];

export const PROVIDER_ORDER: readonly FlagProvider[] = ['posthog', 'flagsmith'];
